import React, { useEffect, useMemo, useState } from 'react'
import { useMyContext } from '../../context/context'
import useSettingsV2 from '../../hooks/useSettingsV2'
import useTranslations from '../../hooks/useTranslations'
import { post } from '../../services/fetch'

const Poll = ({ showTotalVotes = false, data }: any) => {
  const { eventId, domainId } = useMyContext() as any
  const { settings } = useSettingsV2() as any
  const { t } = useTranslations()

  const [hasVotedForPollId, setHasVotedForPollId] = useState(null)
  const [selectedChoiceIds, setSelectedChoiceIds] = useState<number[]>([])
  const [submitting, setSubmitting] = useState(false)

  const maxResponses = Math.max(1, Number(data?.poll?.maxResponses) || 1)
  const isMulti = maxResponses > 1

  const totalVotes = useMemo(() => data?.pollResults.reduce((prev: any, current: any) => prev + Number(current.votes), 0), [data])

  const totalVoters = Number(data?.pollResults?.[0]?.totalVoters) || 0

  useEffect(() => {
    setSelectedChoiceIds([])
  }, [data?.poll?.id])

  const submitChoices = async (choiceIds: number[]) => {
    setHasVotedForPollId(data.poll.id)
    await Promise.all(
      choiceIds.map((id) =>
        post(`/domains/${domainId}/events/${eventId}/polls/${data.poll.id}/pollChoices/${id}`),
      ),
    )
  }

  const voteOrCloseOrResults = () => {
    if (data.eventLive.showResults) {
      return data.pollChoices.map((c: any) => {
        const result = data.pollResults.find((r: any) => r.id === c.id)
        const votes = result?.votes || 0
        const percentage = votes && totalVotes ? (votes * 100) / totalVotes : 0
        return (
          <div>
            <div style={{ color: 'black' }}>
              {c.label} {!data.eventLive.hideVotes && `(${votes} vote${votes > 1 ? 's' : ''} soit ${Math.floor(percentage)}%)`}
            </div>
            <div
              style={{
                animation: 'width0to100 4s ease',
                background: settings?.bgPrimaryColor,
                marginBottom: 20,
                width: `${percentage}%`,
                height: 20,
                minWidth: 1,
              }}
            />
          </div>
        )
      })
    }

    if (data.poll.isClose) {
      return (
        <div
          style={{
            textAlign: 'center',
            fontSize: 22,
            background: settings?.bgPrimaryColor,
            padding: '5px 10px',
            marginBottom: 15,
          }}
        >
          {t('LIVE_TIME_OUT')}
        </div>
      )
    }

    if (data.poll.id === hasVotedForPollId)
      return (
        <div
          style={{
            textAlign: 'center',
            fontSize: 22,
            background: settings?.bgPrimaryColor,
            padding: '5px 10px',
          }}
        >
          {t('LIVE_RECEIVE_ANSWER')}
        </div>
      )
    return (
      <>
        {isMulti && (
          <div style={{ textAlign: 'center', marginBottom: 12, fontSize: 16, opacity: 0.85 }}>
            {`${selectedChoiceIds.length} / ${maxResponses} ${
              maxResponses > 1 ? 'réponses sélectionnées' : 'réponse sélectionnée'
            }`}
          </div>
        )}
        {data.pollChoices.map((c: any) => {
          const selected = selectedChoiceIds.includes(c.id)
          return (
            <div
              style={{
                background: selected ? settings?.bgPrimaryColor : 'transparent',
                color: selected ? settings?.textPrimaryColor : settings?.bgPrimaryColor || '#000',
                border: `2px solid ${settings?.bgPrimaryColor || '#000'}`,
                padding: '5px 10px',
                cursor: 'pointer',
                marginBottom: 20,
                textAlign: 'center',
                fontSize: '1.2em',
              }}
              onClick={() => {
                setSelectedChoiceIds((prev) => {
                  if (prev.includes(c.id)) {
                    return prev.filter((id) => id !== c.id)
                  }
                  if (prev.length >= maxResponses) {
                    return [...prev.slice(1), c.id]
                  }
                  return [...prev, c.id]
                })
              }}
            >
              {c.label}
            </div>
          )
        })}
        <button
          type="button"
          disabled={submitting || selectedChoiceIds.length === 0}
          style={{
            width: '100%',
            background: settings?.bgPrimaryColor,
            color: settings?.textPrimaryColor || '#fff',
            border: 'none',
            padding: '10px 16px',
            fontSize: '1.1em',
            fontWeight: 600,
            cursor: submitting || selectedChoiceIds.length === 0 ? 'not-allowed' : 'pointer',
            opacity: submitting || selectedChoiceIds.length === 0 ? 0.6 : 1,
          }}
          onClick={async () => {
            setSubmitting(true)
            try {
              await submitChoices(selectedChoiceIds)
            } finally {
              setSubmitting(false)
            }
          }}
        >
          {submitting ? '…' : t('VALIDATE') || 'Valider'}
        </button>
      </>
    )
  }

  if (data.poll)
    return (
      <div>
        <div
          style={{
            textAlign: 'center',
            marginBottom: 10,
            fontSize: 28,
            fontWeight: 700,
          }}
        >
          {data.poll.title}
        </div>
        <div style={{ textAlign: 'center', marginBottom: 20, fontSize: 22 }} dangerouslySetInnerHTML={{ __html: data.poll.label }} />
        <div style={{ color: settings?.textPrimaryColor }}>{voteOrCloseOrResults()}</div>
        {showTotalVotes && (
          <div style={{ marginTop: 20, fontSize: 44, fontWeight: 700 }}>
            <div>
              {t('TOTAL_VOTES')} : {totalVotes}
            </div>
            <div>
              {t('TOTAL_VOTERS')} : {totalVoters}
            </div>
          </div>
        )}
      </div>
    )
  return null
}

export default Poll
